
export default {
    state:{
        content:[]
    },
    actions:{
        setContent(ctx,a){
            ctx.commit('updateContent',[])
        }
    },
    mutations:{
        updateContent(state,content){
            state.content =  content
        }
    },
    getters:{
        allContent(state){
            return state.content
        }
    },
}